import Prism from 'prismjs';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-clojure';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-docker';
import 'prismjs/components/prism-elixir';
import 'prismjs/components/prism-elm';
import 'prismjs/components/prism-erlang';
import 'prismjs/components/prism-haskell';
import 'prismjs/components/prism-scss';
import 'prismjs/components/prism-diff';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-kotlin';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-markdown';
import 'prismjs/components/prism-objectivec';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-powershell';
import 'prismjs/components/prism-r';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-rust';
import 'prismjs/components/prism-scala';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-mermaid';
import 'prismjs/components/prism-swift';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-tsx';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-latex';

Prism.manual = true;

type Language = {
  key: string;
  label: string;
  aliases?: string[];
};

export const languageList: Language[] = [
  { key: 'plain', label: 'Plain' },
  { key: 'bash', label: 'Bash', aliases: ['sh', 'shell', 'zsh'] },
  { key: 'cpp', label: 'C++', aliases: ['c', 'cc', 'c++'] },
  { key: 'cs', label: 'C#', aliases: ['c#'] },
  {
    key: 'clojure',
    label: 'Clojure',
    aliases: ['clj', 'cl2', 'cljc', 'cljs'],
  },
  { key: 'scss', label: 'CSS/SCSS', aliases: ['css'] },
  { key: 'diff', label: 'Diff', aliases: ['patch'] },
  {
    key: 'docker',
    label: 'Dockerfile',
    aliases: ['dockerfile'],
  },
  { key: 'elixir', label: 'Elixir', aliases: ['ex', 'exs'] },
  { key: 'elm', label: 'Elm' },
  { key: 'erlang', label: 'Erlang', aliases: ['erl', 'es'] },
  { key: 'go', label: 'Go', aliases: ['golang'] },
  {
    key: 'haskell',
    label: 'Haskell',
    aliases: ['hs', 'hsc'],
  },
  { key: 'xml', label: 'HTML/XML', aliases: ['htm', 'html', 'xhtml'] },
  { key: 'latex', label: 'Tex/KaTeX' },
  { key: 'java', label: 'Java' },
  {
    key: 'javascript',
    label: 'JavaScript',
    aliases: ['js', 'jsx', 'node', 'nodejs'],
  },
  {
    key: 'kotlin',
    label: 'Kotlin',
    aliases: ['kt', 'ktm', 'kts'],
  },
  { key: 'markdown', label: 'Markdown' },
  { key: 'mermaid', label: 'Mermaid' },
  {
    key: 'objectivec',
    label: 'Objective-C',
    aliases: ['obj-c', 'objc'],
  },
  { key: 'powershell', label: 'PowerShell' },
  { key: 'php', label: 'PHP' },
  { key: 'python', label: 'Python', aliases: ['py'] },
  {
    key: 'ruby',
    label: 'Ruby',
    aliases: ['jruby', 'rake', 'rb'],
  },
  { key: 'r', label: 'R' },
  { key: 'rust', label: 'Rust', aliases: ['rs'] },
  { key: 'scala', label: 'Scala' },
  { key: 'sql', label: 'SQL', aliases: ['psql'] },
  { key: 'swift', label: 'Swift' },
  {
    key: 'typescript',
    label: 'TypeScript',
    aliases: ['ts', 'tsx'],
  },
  { key: 'yaml', label: 'YAML', aliases: ['yml'] },
];

export const identifyLanguage = (language: string): string | undefined => {
  const lowercased = language.toLowerCase();
  return languageList.find(
    ({ key, aliases }) => key === lowercased || aliases?.includes(lowercased),
  )?.key;
};

export function getGrammar(language: string | null) {
  switch (language) {
    case 'javascript':
      return Prism.languages.jsx;
    case 'typescript':
      return Prism.languages.tsx;
    case 'xml':
      return Prism.languages.markup;
    default:
      return language ? Prism.languages[language] : undefined;
  }
}

export default Prism;
